import { server_address } from "./Config";
import { RefreshToken, redirectToLogin } from "./TokenOperations";

// The upload limit the server enforces (Backend/utils/uploadImage.js) -
// checked here too so a too-big file fails before minutes of uploading.
export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
export const ACCEPTED_IMAGE_TYPES = 'image/png, image/jpeg, image/gif, image/webp';

// Multipart image upload with progress, for the media pipeline endpoints
// (avatar, group icon). XHR rather than fetch for upload progress.
//
// Always resolves - with the server's JSON, or {status:'fail', code} for a
// network error / non-JSON answer - and handles an expired token the way
// apiRequest does, whatever the HTTP status (the old avatar upload only
// looked at 200s and hung forever on the 403 an expired token gets).
export function uploadImage(path, { file, crop, fields = {}, onProgress, retried = false }) {
    return new Promise((resolve) => {
        const fd = new FormData();
        Object.entries(fields).forEach(([k, v]) => fd.append(k, v));
        if (crop) fd.append('crop', JSON.stringify(crop));
        fd.append('image', file);

        const xhr = new XMLHttpRequest();
        if (onProgress) {
            xhr.upload.addEventListener('progress', (e) => {
                if (e.lengthComputable) onProgress(Math.ceil((e.loaded / e.total) * 100));
            });
        }
        xhr.open('POST', server_address + path, true);
        xhr.setRequestHeader('token', localStorage.getItem('accessToken'));

        xhr.onload = async () => {
            let content;
            try {
                content = JSON.parse(xhr.response);
            } catch (e) {
                resolve({ status: 'fail', code: xhr.status === 413 ? 'FILE_TOO_LARGE' : 'BAD_RESPONSE' });
                return;
            }
            if (content.status === 'expired' && !retried) {
                const refreshed = await RefreshToken();
                if (refreshed === 'expired') {
                    redirectToLogin();
                    resolve(content);
                    return;
                }
                if (refreshed !== 'ok') {
                    resolve({ status: 'fail', code: 'BAD_RESPONSE' });
                    return;
                }
                resolve(await uploadImage(path, { file, crop, fields, onProgress, retried: true }));
                return;
            }
            if (content.status === 'rate_limited') content.code = 'RATE_LIMITED';
            resolve(content);
        };
        xhr.onerror = () => resolve({ status: 'fail', code: 'NETWORK' });
        xhr.send(fd);
    });
}
